"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationSummaryTotalBlock = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
require("./index.scss");
const PriceItem = (props) => {
    const { label, priceText } = props;
    if (!priceText)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}-total-item` },
        react_1.default.createElement("div", { className: `${__1.className}-total-item__label` }, label),
        react_1.default.createElement("div", { className: `${__1.className}-total-item__value` }, priceText)));
};
const ReservationSummaryTotalBlock = (props) => {
    const { bookedPriceText, totalPriceText, } = props;
    if (!totalPriceText && !bookedPriceText)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__block` },
        react_1.default.createElement(PriceItem, { label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:BookedPrice', defaultMessage: 'Booked price' })), priceText: bookedPriceText }),
        react_1.default.createElement(PriceItem, { label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:TotalPrice', defaultMessage: 'Total price' })), priceText: totalPriceText })));
};
exports.ReservationSummaryTotalBlock = ReservationSummaryTotalBlock;
//# sourceMappingURL=index.js.map